export const ConceptConstants = {
    FIXED_ADDITIONAL_CONCEPT_ID: -1,
    FIXED_ADDITIONAL_CONCEPT_NAME: "Additional results",
    FIXED_ADDITIONAL_CONCEPT_DESCRIPTION: "This concept can be used to create technologies underneath.",
    FIXED_WITHOUT_CONCEPT_ID: -2,
    FIXED_WITHOUT_CONCEPT_NAME: "Without concept",
} as const;